const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/inventory`;

const request = async (path, options = {}) => {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Error ${res.status}`);
  return data;
};

export const inventoryApi = {
  units: () => request('/units'),
  items: () => request('/items'),
  createItem: (body) => request('/items', { method: 'POST', body }),
  updateItem: (id, body) => request(`/items/${id}`, { method: 'PATCH', body }),
  deleteItem: (id) => request(`/items/${id}`, { method: 'DELETE' }),
  addMovement: (id, body) => request(`/items/${id}/movement`, { method: 'POST', body }),
  movements: (params = {}) => request(`/movements?${new URLSearchParams(Object.entries(params).filter(([, v]) => v))}`),
  recipes: () => request('/recipes'),
  setRecipe: (menuId, recipe) => request(`/recipes/${menuId}`, { method: 'PUT', body: { recipe } }),
  createDirect: (menuId) => request(`/recipes/${menuId}/direct`, { method: 'POST' }),
  menuStatus: () => request('/menu-status'),
  alerts: () => request('/alerts'),
  report: (date) => request(`/report${date ? `?date=${date}` : ''}`),
};

export const fmtQty = (n) => {
  const v = Number(n) || 0;
  return Number.isInteger(v) ? String(v) : v.toFixed(2);
};

export const localToday = () => new Date(Date.now() - 6 * 3600 * 1000).toISOString().split('T')[0];

export const MOVEMENT_LABELS = {
  entrada: { label: 'Entrada', cls: 'bg-emerald-900/40 text-emerald-300' },
  merma: { label: 'Merma', cls: 'bg-red-900/40 text-red-300' },
  ajuste: { label: 'Ajuste', cls: 'bg-blue-900/40 text-blue-300' },
  venta: { label: 'Venta', cls: 'bg-orange-900/40 text-orange-300' },
  devolucion: { label: 'Devolución', cls: 'bg-purple-900/40 text-purple-300' },
};
